import { api } from "~/api";
import { defineComponent, reactive } from "vue";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { commonStore } from "~/store/CommonStore";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { PageID } from "~/extensions/utils/DefineTypes";
import { myPageStore } from "~/store/MyPageStore";
const log = Log.create("TaikyoComplete");
export default defineComponent({
    components: {
        BreadcrumbList
    },
    name: "TaikyoCompletePage",
    beforeRouteEnter(to, from, next) {
        if (from.name === "kaiyaku-guide" || !from.name) {
            next();
            return;
        }
        next(false);
    },
    async setup() {
        let html = reactive({
            value: ""
        });
        // 画面名取得
        const pageName = commonStore.pageName(PageID.taikyoComplete);
        const isMultipleKeiyaku = myPageStore.isMultipleKeiyaku;
        try {
            let result = await api.taikyo.loadCompleteText();
            html.value = result;
        }
        catch (ex) {
            log.error("setup", ex);
            MsgBox.error(ex.message);
        }
        return {
            html,
            pageName,
            PageID,
            isMultipleKeiyaku
        };
    }
});
